// extracted by mini-css-extract-plugin
module.exports = {"ArticleCarousel":"ArticleCarousel_ArticleCarousel__3w0z3","IntiDinamis":"ArticleCarousel_IntiDinamis__16P4z"};